export default __webpack_public_path__ + "static/media/charactor.3476911a.png";